import axios from 'axios';
import api_url from '../urls';
const actions = {

    fazerLogin (context, dados) {

        axios.post(api_url.api_admin + 'auth/login', 
        {
         email: dados.email,
         password: dados.password

         }).then(response =>{
           //  console.log(response.data.access_token)
             localStorage.access_token = response.data.access_token;
             this.$router.push({ name: 'administrador/home' })
         }).catch(error=>{
            console.log(error);
           localStorage.removeItem('access_token');
           
          });

    }
}

export default actions